import React, { useState, useEffect } from "react";
import Navbar from "../Layout/Navbar";
import Crew from "./Crew/Crew";
import Aircraft from "./Aircraft";
import Simulator from "./Simulator/Simulator";
import Ground from "./Ground";
import Manager from "./Manager";
import firebase from "../../Firebase/firebase";
import { useQuery } from "@apollo/client";
import { HoverProfileQuery } from "../HoverProfile/Queries/HoverProfileQuery";
import DataAdmin from "./DataAdmin";
import Footer from "../Layout/Footer";
import HoverProfile from "../HoverProfile/HoverProfile";
import "./../../assets/styles/custom/components/Dashboard.scss";
import Loading from "./../../assets/images/loading.gif";

import { useHistory } from "react-router-dom";

const Dashboard = (props) => {
  const [toggle, settoggle] = useState(false);
  const [hoverProfile, sethoverProfile] = useState(false);

  
  const dashboardComponents = () => {
    const component = window.location.pathname.split("/")[2];
    if (component == "simulator") {
      return <Simulator props={props} />;
    } else if (component == "ground") {
      return <Ground props={props} />;
    } else if (component == "manager") {
      return <Manager props={props} />;
    } else if (component == "data-admin") {
      return <DataAdmin props={props} />;
    } else if (component == "crew") {
      return <Crew props={props} />;
    } else if (component == "aircraft") {
      return <Aircraft props={props} />;
    }
  };
  const [users, setusers] = useState({});
  let history = useHistory();
  //new start
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else {
        history.push("/")
        console.log("SIGNED OUT");
      }
    });
  }, []);
  const changeToggle = () => {
    settoggle(!toggle);
    setTimeout(() => {
      settoggle(false);
    }, 5000);
  };
  const { data } = useQuery(HoverProfileQuery, {
    variables: { id: users?.token?.claims?.user_id },
  });
  return (
    <>
      <div className="dashboard-container">
        <Navbar toggle={toggle} />
        <div className="dashboard-right-part">
          <div className="dashboard-right-header">
            {/* <div
              className="fa fa-bars"
              onClick={() => settoggle(!toggle)}
            /> */}
            <div className="fa fa-bars" onClick={() => changeToggle()} />
            <div className="dashboard__right">
              <div className="dashboard__name">
                <b>Welcome</b> &nbsp;
                {users?.token?.claims?.user_id &&
                  data?.aatmsv4_register?.length === 1 &&
                  data
                  ? data?.aatmsv4_register[0]?.name
                  : null}
              </div>
              &nbsp;&nbsp;&nbsp;
              <div
                className="dashboard-right-header-profile"
                onClick={() => sethoverProfile(!hoverProfile)}
                onMouseEnter={() => sethoverProfile(!hoverProfile)}
              >
                <img
                  src={
                    data?.aatmsv4_register?.length === 1 &&
                      users?.token?.claims?.user_id
                      ? data?.aatmsv4_register[0]?.photo
                      : Loading
                  }
                  height="100%"
                  alt=""
                  width="100%"
                />
              </div>
            </div>
          </div>
          <div className="dashboard-right-body">{dashboardComponents()}</div>
          <Footer />
        </div>
      </div>
      <HoverProfile
        hoverProfile={hoverProfile}
        onMouseLeave={() => sethoverProfile(!hoverProfile)}
      />
    </>
  );
};

export default Dashboard;
